/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';

const pathname = '/sections';

export const SectionApi = {
  checkDuplicate: async (option?: CheckDuplicateSectionCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async (option: GenerateSectionCodeQuery) => {
    let url = `${pathname}/generate-code`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindForSection {
  page?: number;
  take?: number;
  select?: string[];
  order?: any;
  where?: any;
}

export interface CheckDuplicateSectionCodeQuery {
  code: string;
  entityProductObjectID?: string;
}

export interface GenerateSectionCodeQuery {
  entityProductObjectID: string;
}
